import api from './api';

// `config` opsiyoneldir: ApprovalsHubPage.js parametresiz çağırır (normal hata
// akışı). hooks/useApprovalsBadge.js açık tazelemede { skipErrorToast: true }
// geçer — rozetin arka plan okuması kullanıcıya sahte hata toast'ı gösteremez
// (getApprovalSummaryCount ile AYNI ilke, bkz. Görev 4 fix).
export const getApprovalSummary = (config) => api.get('/v1/approvals/summary', config);

// Rozet arka planda okur — sahte hata toast'ı gösteremez.
export const getApprovalSummaryCount = () =>
  api.get('/v1/approvals/summary/count', { skipErrorToast: true });
